import { combineReducers } from 'redux';
import trainingHub from './trainingHub/reducers';

const createRootReducer = () =>
  combineReducers({
    trainingHub,
  });

export default createRootReducer;
